import { OnInit, Component, OnDestroy, Input } from '@angular/core';
import { interval } from 'rxjs';
import { MessageStorage } from 'util/MessageStorage';
import { INVALID_TOKEN_PRODUCT } from 'providers/http/ErrorInterceptor';
import { Router } from '@angular/router';
import { TokenStorage } from 'providers/TokenStorage';
import { OptionsHttp } from 'providers/http/OptionsHttp';
import { MainHttp } from 'providers/http/MainHttp';
import { LoginHttp } from 'providers/http/LoginHttp';

declare let SYSTEM_CONST;
declare let PRODUCT;

@Component({
    selector: 'profile-lobby',
    templateUrl: './ProfileLobby.html',
    styleUrls: ['./ProfileLobby.css'],
    providers: []
})
export class ProfileLobby implements OnInit, OnDestroy {
    
    @Input() show = false;
    
    body = $('body');
    visible = 'menubar-visible';
    fullHeigth = $('body').height() - 72;
    PRODUCT: any;

    username: any = '';
    profileImage: any = '';
    initialsName: any = '';
    
    errorMessage: string;
    /**
     * determina si el header es visible o no
     */
    headerFlag = true;

    visibleSplash = true;

    SYSTEM_CONST: any;
    /**
     * actual usuario logeado
     */
    currentUserId: string;
    constructor(private router: Router,
        private tokenStorage: TokenStorage,
        private optionsHttp: OptionsHttp,
        private mainHttp: MainHttp,
        private loginHttp: LoginHttp) {
        this.PRODUCT = PRODUCT.LUDYACCOUNT;
    }

    getLoggedUserData() {
        this.mainHttp.getLoggedUserData().then((response) => {
            this.showSplash();
            if (response != null) {
                if (response.firstName != null && response.firstName != '') {
                    if (response.lastName != null && response.lastName != '') {
                        this.username = response.firstName + ' ' + response.lastName;
                    } else {
                        this.username = response.firstName;
                    }
                } else {
                    this.username = response.username;
                }
                if (response.profileImageUrl == null || response.profileImageUrl == '') {
                    if (response.initialsName == null || response.initialsName == '') {
                        this.profileImage = 'images/user2.jpg';
                        $('#usernameProfile').removeClass('top-username-initials-name');
                    } else {
                        this.initialsName = response.initialsName;
                        $('#usernameProfile').addClass('top-username-initials-name');
                        this.profileImage = null;
                    }
                } else {
                    this.profileImage = response.profileImageUrl;
                    $('#usernameProfile').removeClass('top-username-initials-name');
                }
                this.currentUserId = response.agentId;
            }
        });
    }

    showSplash() {
        setTimeout(() => {
            $('#splash').remove();
            this.visibleSplash = false;
        },500);
    }

    logOut() {
        this.loginHttp.logOut().subscribe((response) => {
            this.tokenStorage.resetToken();
            this.tokenStorage.deleteCookie();
        },
        (error) => {
            MessageStorage.add('error', error.errorMessage);
        });
        this.tokenStorage.resetToken();
        this.tokenStorage.deleteCookie();
        // localStorageFilter.set('dash',null);
        localStorage.reloadToLudyAccount = 'true';
        window.location.href = '#/login';
    }


    showMaintenanceMsg() {
        let msg = localStorage.getItem('maintenanceMsg');
        if (msg !== null && this.tokenStorage.getToken()) MessageStorage.add('warning', msg);
    }

    loadMaintenanceMsg() {
        this.showMaintenanceMsg();
        interval(300000).subscribe(
          () => {
            this.showMaintenanceMsg();
          }
        );
    }
    
    ngOnInit() {
        $('body').removeAttr('style');
        $('body').removeClass().addClass('home-body');
        this.getLoggedUserData();
        this.loadMaintenanceMsg();
    }

    ngOnDestroy() {
    }
}
